module.exports = __webpack_public_path__ + "static/media/IoB Stack - GBR Network - 25-09-2024.07c7b884.png";